import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from '../../../components/layout/Breadcrumb';

export default function DocumentRequestList() {
    const navigate = useNavigate();
    const location = useLocation();
    const DocsRequestsList = [
        {
            requestID: "#DR567",
            name: "Amit Kumar",
            document: "Final Year Marksheet",
            Date: "10-01-2025",
            status: "Approved",
            action: 
            <button type="button" className="btn-interactive" onClick={() => navigate('/admin/DocumentRequestList/Report',{
                state:{
                    from: "DocumentRequestList",
                    fromPath: location.pathname
                }
            })} >
            <img src={require("assets/img/view-icon.png")} alt="view" style={{width: "17px", height: "19px", cursor: "pointer"}}
            /> 
            </button>
        },
        {
            requestID: "#DR587",
            name: "Sonu Kumar",
            document: "Intermediate Passing Certificate",
            Date: "15-02-2025",
            status: "Pending",
            action: 
             <button type="button" className="btn-interactive" onClick={() => navigate('/admin/DocumentRequestList/Report')}>
            <img src={require("assets/img/view-icon.png")} alt="view" style={{width: "17px", height: "19px", cursor: "pointer"}}  /> 
            </button>
        }
    ];

    return (
        <div className='container-fluid'>
            <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: '18px' }}>
                <div className="icons-list">
                    <Breadcrumb />
                </div>
            </div>
            {/* leave request list table */}
            <div className='section-body'>
                <div className='container-fluid'>
                    <div className='tab-content'>
                        <div className='tab-pane fade active show' id="Employee-list" role='tabpanel'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='request-list-table'>
                                        <table className='table table-hover table-vcenter text-nowrap mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>Request ID</th>
                                                    <th>Employee Name</th>
                                                    <th>Document</th>
                                                    <th>Date</th>
                                                    <th>Status</th>
                                                    <th>View</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {DocsRequestsList.map((request, index) => (
                                                    <tr key={request.requestID}>
                                                        <td>{request.requestID}</td>
                                                        <td>{request.name}</td>
                                                        <td>{request.document}</td>
                                                        <td>{request.Date}</td>
                                                        <td>{request.status}</td>
                                                        <td>{request.action}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
